module.exports = {
    title: {
        en: "NETTIPYORA.FI",
        fi: "NETTIPYÖRÄ.FI"
    },
    disclaimer: {
        en: "Nettipyora.fi does not encourage any malicious behaviours e.g. theft and is willing to take any necessary steps to make this service lawful, trustworthy and reliable.",
        fi: "Nettipyörä.fi ei kannusta rikolliseen toimintaan, kuten varastamiseen, ja olemme valmiita tekemään kaikkemme pitääksemme palvelumme lainmukaisena ja luotettavana."
    },
    adviceText1: {
        en: "You should always be careful if the offer or the item listed seems too good to be true. Always test ride/try before purchasing. And try get as much information as you can of the listed item.",
        fi: "Olethan varuillasi, mikäli ilmoituksen tuote vaikuttaa liian hyvältä ollakseen totta. Hanki mahdollisimman paljon tietoa tuotteesta ja koeaja tai kokeile tuotetta aina ennen maksamista."
    },
    adviceText2: {
        en: "For safe cycling, use a good bicycle and appropriate equipment. During dark winter, bicycles must be equipped with a light. For even greater safety, remember to wear a helmet.",
        fi: "Turvallisuutesi vuoksi aja vain ehjällä pyörällä ja käytä suojavarusteita pyöräillessä. Talviaikaan pyörissä tulee olla valo. Muista kypärä."
    }
};